import { CoursesById } from "../modules";

export const CoursesByIdPage = () => {
  return <CoursesById />;
};
